import { DeviceConfig } from '@accedo/xdk-config'
import { ID as WEBOS } from '@accedo/xdk-device-lg-webos'
import { ID as TIZEN } from '@accedo/xdk-device-samsung-tizen'
import { ID as VIZIO } from '@accedo/xdk-device-vizio-smartcast-contrib'
import { ID as WORKSTATION } from '@accedo/xdk-device-workstation'
import { tts } from '@accedo/xdk-extensions-contrib'
import { LOG_LEVELS } from '@accedo/xdk-log'

const { html5: html5TtsConfig } = tts
const { webos: webosTtsConfig } = tts
const { vizio: vizioTtsConfig } = tts

const hlsjs = {
  default: true,
  id: 'hls-player',
  importer: () => import('@accedo/xdk-local-modules/src/HlsPlayer'),
}

const loadWith =
  (...player) =>
  (configInvoker) =>
  async () => {
    const conf = await configInvoker()
    conf.default.players = [...player, ...conf.default.players]
    return conf
  }

const knownPlayers = { hlsjs }

export const enabledPlayers = () =>
  Object.values(knownPlayers).filter(() => {
    return true
  })

const loadWithAll = loadWith(hlsjs)

export default {
  devices: {
    packages: [
      new DeviceConfig({
        id: TIZEN,
        detection: () => import('@accedo/xdk-device-samsung-tizen/esm/detection'),
        defaultConfig: loadWithAll(() =>
          import('@accedo/xdk-device-samsung-tizen/esm/defaultConfig'),
        ),
        DevicePackage: () => import('@accedo/xdk-device-samsung-tizen/esm/DevicePackage'),
      }).addExtension(html5TtsConfig),
      new DeviceConfig({
        id: WEBOS,
        detection: () => import('@accedo/xdk-device-lg-webos/esm/detection'),
        defaultConfig: loadWithAll(() => import('@accedo/xdk-device-lg-webos/esm/defaultConfig')),
        DevicePackage: () => import('@accedo/xdk-device-lg-webos/esm/DevicePackage'),
      }).addExtension(webosTtsConfig),
      new DeviceConfig({
        id: VIZIO,
        detection: () => import('@accedo/xdk-device-vizio-smartcast-contrib/esm/detection'),
        defaultConfig: loadWithAll(() =>
          import('@accedo/xdk-device-vizio-smartcast-contrib/esm/defaultConfig'),
        ),
        DevicePackage: () => import('@accedo/xdk-device-vizio-smartcast-contrib/esm/DevicePackage'),
      }).addExtension(vizioTtsConfig),
      new DeviceConfig({
        id: WORKSTATION,
        detection: () => import('@accedo/xdk-device-workstation/esm/detection'),
        defaultConfig: loadWithAll(() =>
          import('@accedo/xdk-device-workstation/esm/defaultConfig'),
        ),
        DevicePackage: () => import('@accedo/xdk-device-workstation/esm/DevicePackage'),
      }).addExtension(html5TtsConfig),
    ],
    logging: {
      level: LOG_LEVELS.ALL, // restrict the logs
    },
  },
}
